import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { settingsKeys } from 'core/query-client/keys/settings.keys';
import { OperatorCustomNotification } from 'modules/settings/pods/settings-operator-custom-notifications/operator-custom-notification.vm';
import { getOperatorCustomNotificationById } from 'modules/settings/pods/settings-operator-custom-notifications/service/operator-custom-notifications.service';

interface UseOperatorCustomNotificationDetailProps {
    notificationId?: string;
    enabled: boolean;
}

export const useOperatorCustomNotificationDetail = ({
    notificationId,
    enabled,
}: UseOperatorCustomNotificationDetailProps) => {
    const {
        data: notification,
        isFetching: isLoadingNotification,
        isError: hasFailedToLoadNotification,
    } = usePocQuery<OperatorCustomNotification>({
        queryKey: settingsKeys.operatorCustomNotificationDetail(notificationId),
        queryFn: () => getOperatorCustomNotificationById(notificationId ?? ''),
        enabled: enabled && Boolean(notificationId),
    });

    return {
        notification,
        isLoadingNotification,
        hasFailedToLoadNotification,
    };
};
